<ng-container *ngIf="src">

  <img *ngIf="isBot || noLazyLoad; else noBot"
       [src]="srcSingle"
       [sizes]="sizes"
       [title]="title"
       [alt]="alt"
       [srcset]="srcList"
       [style.object-position]="position"
  />

  <ng-template #noBot>
    <ng-container [ngSwitch]="mode">

      <ng-container *ngSwitchCase="'div'">
        <div
            [class]="cssClass"
            [defaultImage]="lazyLoadDefaultImage"
            [lazyLoad]="srcSingle"
            [style.background-position]="position"
        >
        </div>
      </ng-container>

      <ng-container *ngSwitchCase="'img'">
        <img
            [alt]="alt"
            [class]="cssClass"
            [defaultImage]="lazyLoadDefaultImage"
            [lazyLoad]="srcList"
            [sizes]="sizes"
            [style.object-position]="position"
            [title]="title"
            [useSrcset]="isResponsive"
        />
      </ng-container>
    </ng-container>
  </ng-template>
</ng-container>
